import { render } from "./user-tournament.vue?vue&type=template&id=09064888"
import script from "./user-tournament.vue?vue&type=script&lang=js"
export * from "./user-tournament.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__